import { removeNonAlphanumeric } from '@/helpers/common';

export const BIRTHDAY_PROMOCODE = 'bday';

export const promocodeNormalizer = (promocode: string) =>
  removeNonAlphanumeric(promocode).toLowerCase();

export const scrollToPromoCodeInput = (
  ref: React.RefObject<HTMLElement>,
  offset = 0,
  behavior: ScrollBehavior = 'auto'
) => {
  if (!ref.current) return;

  const top = window.scrollY + ref.current.getBoundingClientRect().top - offset;

  window.scrollTo({ top, behavior });
};
